import { useRouteHead } from '@/seo/useRouteHead';

/**
 * Invisible component that keeps the document head in sync with the current route.
 * Mount once per layout (Marketing, App, Auth, Onboarding).
 */
export function RouteHead() {
  useRouteHead();
  return null;
}
